<template>
    <div>
        <h1>Frontpage</h1>

        <div class="card">
            <div class="card-body">
                <router-link to="/admin/indicators" class="btn btn-success btn-lg">Change indicators</router-link>
                <router-link to="/admin/sessions" class="btn btn-success btn-lg ml-3">Change sessions</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'frontpage-index'
    }
</script>